import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Github, Twitter, Linkedin, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_f913202c-f556-4e67-8289-1cc1bbfe81d7/artifacts/l0uotybx_Logo%20de%20claudtexa%20con%20fondo%20transparante.png";

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Slogan */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img src={LOGO_URL} alt="CloudTexa" className="h-16 w-auto" />
            </Link>
            <p className="text-lg text-gray-400 italic">
              "{t('footer.slogan')}"
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Enlaces</h4>
            <nav className="space-y-2">
              <a href="/#services" className="block text-gray-400 hover:text-white transition-colors">
                {t('nav.services')}
              </a>
              <Link to="/pricing" className="block text-gray-400 hover:text-white transition-colors">
                {t('nav.pricing')}
              </Link>
              <a href="/#about" className="block text-gray-400 hover:text-white transition-colors">
                {t('nav.about')}
              </a>
              <a href="/#contact" className="block text-gray-400 hover:text-white transition-colors">
                {t('nav.contact')}
              </a>
            </nav>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-semibold mb-4">Social</h4>
            <div className="flex gap-3">
              <a
                href="#"
                className="p-2 rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
                data-testid="social-github"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="p-2 rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="p-2 rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="p-2 rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {currentYear} CloudTexa. {t('footer.rights')}.
          </p>
          <div className="flex gap-4 text-sm text-gray-500">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
